<template>
    <aside class="col-12 col-md-4 col-lg-3 col-xl-3 aside">
        <div class="sidebar-box border-0 pb-0" v-if="tournamentNews.length">
            <strong class="h2 text-uppercase">Tournament News</strong>
            <div class="sidebar-box-inner">
                <ul class="category-list">
                    <li  v-for="tournamentNew in tournamentNews" :key="tournamentNew.id">
                        <router-link :to="{ name: 'tournamentNews', params: { tournament:tournamentNew.slug }}" class="nav-link">
                            {{tournamentNew.name}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sidebar-box border-0 pb-0">
            <strong class="h2 text-uppercase">Download app</strong>
            <div class="sidebar-box-inner">
                <ul class="download-apps-btn">
                    <li>
                        <a  target="_blank" href="https://apps.apple.com/gb/app/planetcricket/id1562153858">
                            <img width="135" height="40" loading="lazy" class="lazyload" :src="require('@/assets/images/app-store.png')" alt="app store" /></a>
                    </li>
                    <li>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.sportcc.planetcricket">
                            <img width="135" height="40" loading="lazy" class="lazyload" :src="require('@/assets/images/google-play.png')" alt="google play" /></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sidebar-box border-0 pb-0">
            <strong class="h2 text-uppercase">Follow Us</strong>
            <div class="sidebar-box-inner">
                <ul class="social-networks">
                    <li><a target="_blank" href="https://www.facebook.com/Planet-Cricket-128732262729917"><img  width="30" height="30" :src="$vuePublicPath('/images/facebook.png')" alt="facebook"></a></li>
                    <li><a target="_blank" href="https://www.instagram.com/planetcricketlive/"><img loading="lazy" width="30" height="30" :src="$vuePublicPath('/images/instagram.png')" alt="instagram"></a></li>
                    <li><a target="_blank" href="https://www.linkedin.com/in/planet-cricket-73a667222/"><img  width="30" height="30" :src="$vuePublicPath('/images/linkedin.png')" alt="linkedin"></a></li>
                    <li><a target="_blank" href="https://twitter.com/Tplanetcricket"><img loading="lazy" width="30"  height="30" :src="$vuePublicPath('/images/twitter.png')" alt="twitter"></a></li>
                    <li><a target="_blank" href="https://www.youtube.com/channel/UCNmTXbp-Q1Ie5PNSrkIHKtA"><img width="30" height="30" :src="$vuePublicPath('/images/youtube.png')" alt="youtube"></a></li>
                </ul>
            </div>
        </div>
        <div class="text-center" v-if="!is_data_ready">
            <span class="loader"></span>
        </div>
        <div v-else>
            <div class="aside-box" v-if="newsList.length >= 1 && $route.name != 'newsList'">
                <strong class="h2 text-uppercase">LATEST NEWS</strong>
                <div class="row post-holder">
                    <div class="post col-sm-6 col-md-12" v-for="news in newsList" :key="news.id">
                        <router-link :to="{ name: 'newsArticle', params: { news: news.slug, ...(news.match) && {match: news.match.slug} } }">
                            <div class="img-holder">
                                <link v-if="!$store.state.isMobile" rel="preload" :href="news.image_url ? news.image_url.resizeImage(295) : ''" as="image">
                                <img v-if="$store.state.isMobile" loading="lazy" :src="news.image_url ? news.image_url.resizeImage(295) : ''" width="295" height="165" alt="image description" />
                                <img v-else :src="news.image_url ? news.image_url.resizeImage(295) : ''" width="295" height="165" alt="image description" />

                            </div>
                            <div class="descrip">
                                <h3>{{ news.heading }}</h3>
                                <p>{{ news.subheading }}</p>
                                <time class="time" :datetime="news.created_at | formatDate('YYYY-MM-DD')">
                                      {{ news.created_at | timeElaped }}
                            </time>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="aside-box" v-if="highlights.length >= 1 && $route.name != 'highlights'">
            <strong class="h2 text-uppercase">Must-see highlights</strong>
            <div class="row post-holder">
                <div class="post col-sm-6 col-md-12" v-for="highlight in highlights" :key="highlight.id">
                    <a href="javascript:;">
                        <span v-html="highlight.highlight"></span>
                    </a>
                    <div class="descrip">
                        <h3>
                            <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: highlight.match.slug } }">
                                {{ highlight.title }}
                        </router-link>
                    </h3>
                    <time class="time" :datetime="highlight.created_at | formatDate('YYYY-MM-DD')">
                          {{ highlight.created_at | timeElaped }}
                </time>
            </div>
        </div>
    </div>
</div>
</div>
</aside>
</template>

<script>
    export default {
        name: 'rightSidebar',

        data() {
            return {
                newsList: [],
                highlights: [],
                tournamentNews:[]
            }
        },
        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                  let videos = []
               this.highlights.forEach((video) => {
                videos.push(
                        {
                            "@type": "VideoObject",
                            "name": video.title,
                            "description": video.title,
                            "thumbnailUrl": [
                                process.env.BASE_URL + 'public/images/logo1280x720.png'
                            ],
                            "uploadDate": video.created_at,
                            "contentUrl": process.env.BASE_URL,
                            "embedUrl": process.env.BASE_URL,
                        }
                )
            });
            let articles = [];
            this.newsList.forEach((article) => {
                articles.push(
                        {
                            '@type': 'NewsArticle',
                            mainEntityOfPage: {
                                '@type': 'WebPage',
                                '@id': "https://planetcricket.com" + this.$route.path
                            },
                            headline: article.heading,
                            description: article.subheading,
                            image: article.image_url,
                            author: {
                                '@type': 'Person',
                                name: article.author,
                                "url" : process.env.BASE_URL
                            },
                            publisher: {
                                '@type': 'Organization',
                                name: 'Planet Cricket',
                                logo: {
                                    '@type': 'ImageObject',
                                    url: process.env.BASE_URL + 'public/images/logo1280x720.png'
                                }
                            },
                            datePublished: article.created_at,
                            dateModified: article.updated_at
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": [articles,videos]
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
//            this.loadTournamentNews()
        },

        methods: {
            async main() {
                await this.$axios
                        .get(this.$NEWS_LIST_API, {params: {per_page: 3}})
                        .then(response => {
                            this.newsList = response.data.result.news || [];
                            this.newsList.forEach(function (news) {
                                $root.$preload(news.image_url.resizeImage(295), ['image']); // for google page speed
                            }); 
                        })
                        .catch(error => console.log(error))
                
                    await this.loadTournamentNews();
                    
                return this.$axios
                        .get(this.$HIGHLIGHTS_API, {params: {per_page: 3}})
                        .then(response => {
                            this.is_data_ready = true
                            this.highlights = response.data.result.highlights.data || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
                 
            },
            loadTournamentNews(){
                return this.$axios
                        .get(this.$TOURNAMENT_NEWS_LIST_API)
                        .then(response => {
                            this.is_data_ready = true
                            this.tournamentNews = response.data.result.tournaments || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>
